import type { NotificationPreferencesTranslations } from "../interfaces/notificationPreferences";

export const notificationPreferencesTranslations: NotificationPreferencesTranslations = {
  status_coming_soon: "COMING SOON",
  message_show: "View message",
  message_hide: "Hide message",

  preview_label: "Preview",
  preview_verified_title: "Verified",
  preview_language_note: "Messages are sent in Spanish",
  preview_footer: "Coloca Payments",

  test_phone_label: "Test number",
  test_phone_help:
    "Tests only go to this number, so you can see each message on your phone before turning it on.",
  send_test_button: "Send test",
  send_test_to: "Goes to {{phone}}",
  send_test_needs_phone: "Enter a number above to test this alert.",
  send_test_sent: "Sent",
  send_test_placeholder: "Phone number",
  send_test_invalid: "Invalid number for the selected country",
  send_test_success: "Test message sent over WhatsApp",
  send_test_skipped: "That alert is turned off on the WhatsApp service. The test was not sent.",

  update_success: "Preference updated",
  active_types: "Active types",
};
